import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import * as TotalReportsService from "_services/total-reports";
// date
import moment from 'moment';

// functions to convert array items to text for csv export
const convertArrayToCSV = (arr) => {

  let headers = ["flight", "average", "actual", "date", "time", "id"];
  const headerRow = headers.join(",");

  // process each flight forecast
  const rows = arr
    .map((flightForecast) => {
      let average = parseInt(flightForecast.average).toFixed(1);

      // map the flight forecast values to the corresponding header
      return headers
        .map((header) => {
          switch (header) {
            case "flight":
              return flightForecast.flight;
            case "average":
              return average;
            case "actual":
              return flightForecast.actual;
            case "date":
              return moment(flightForecast.formattedTime).format('MMMM Do YYYY')
            case "time":
              return flightForecast.time;
            case "id":
              return flightForecast.id;
            default:
              return "";
          }
        })
        .join(",");
    })
    .join("\n");

  return headerRow + "\n" + rows;
}

const initialState = {

  loadingStatus: "idle",

  // departure booking report flags
  departureBookingsReport: [],
  getDepartureBookingsReportStatus: "idle",
  getDepartureBookingsReportError: null,

  // arrival booking report flags
  arrivalBookingsReport: [],
  getArrivalBookingsReportStatus: "idle",
  getArrivalBookingsReportError: null,

  // Passengers Record reports flags
  passengersRecordReport: [],
  getPassengersRecordReportStatus: "idle",
  getPassengersRecordReportError: null,

  // departure forecast report flags
  departureForecastReport: [],
  getDepartureForecastReportStatus: "idle",
  getDepartureForecastReportError: null,
  analyticsCountOutboundByHourForForecast: null,
  getAnalyticsCountOutboundByHourForForecastStatus: "idle",
  getAnalyticsCountOutboundByHourForForecastError: null,

  // arrival forecast report flags
  arrivalForecastReport: [],
  getArrivalForecastReportStatus: "idle",
  getArrivalForecastReportError: null,
  analyticsCountInboundByHourForForecast: null,
  getAnalyticsCountInboundByHourForForecastStatus: "idle",
  getAnalyticsCountInboundByHourForForecastError: null,

  selectedReport: null,

  // SLA report flags
  SLAReport: null,
  getSLAReportStatus: "idle",
  getSLAReportError: null,

  // airline perfomrance
  AirlinePerformanceReport: null,
  getAirlinePerformanceReportStatus: "idle",
  getAirlinePerformanceReportError: null,


  // employee conversations
  employeeConvReport: [],
  getEmployeeConvReportStatus: "idle",
  getEmployeeConvReportError: null,

  // flights list
  flightsListReport: [],
  getFlightsListReportStatus: "idle",
  getFlightsListReportError: null,

  // flight messages by conversation id
  flightMessagesByConversationId: [],
  getFlightMessagesByConversationIdStatus: "idle",
  getFlightMessagesByConversationIdError: null,

  // flights schedule report
  flightsScheduleReport: null,
  getFlightsScheduleReportStatus: "idle",
  getFlightsScheduleReportError: null,

  // breaks report
  breaksReport: null,
  getBreaksReportStatus: "idle",
  getBreaksReportError: null,

  // gate changes report
  gateChangesReport: null,
  getGateChangesReportStatus: "idle",
  getGateChangesReportError: null,

  // vehicle/equipment report
  vehicleReport: null,
  getVehicleReportStatus: "idle",
  getVehicleReportError: null,

  // third state flights report
  thirdStateFlightsReport: null,
  getThirdStateFlightsReportStatus: "idle",
  getThirdStateFlightsReportError: null,

  // sunflower lanyard marketplace report
  sunflowerReport: null,
  getSunflowerReportStatus: "idle",
  getSunflowerReportError: null,

};

export const getDepartureBookingsReport = createAsyncThunk(
  "totalReports/getDepartureBookingsReport",
  async (params, signal) => {
    return TotalReportsService.getBookingsReport(params, signal);
  }
);

export const getArrivalsBookingsReport = createAsyncThunk(
  "totalReports/getArrivalsBookingsReport",
  async (params, signal) => {
    return TotalReportsService.getBookingsReport(params, signal);
  }
);

export const getPassengersRecordReport = createAsyncThunk(
  "totalReports/getPassengersRecordReport",
  async (params, signal) => {
    return TotalReportsService.getBookingsReport(params, signal);
  }
);

export const getDepartureForecastReport = createAsyncThunk(
  "totalReports/getDepartureForecastReport",
  async (params, signal) => {
    return TotalReportsService.getForecastReport(params, signal);
  }
);

export const getAnalyticsCountOutboundByHourForForecast = createAsyncThunk(
  "totalReports/getAnalyticsCountOutboundByHourForForecast",
  async (params, signal) => {
    return TotalReportsService.getBookingsCount(
      { ...params, type: "outbound", byHour: true, source: 'none' },
      signal
    );
  }
);

export const getArrivalForecastReport = createAsyncThunk(
  "totalReports/getArrivalForecastReport",
  async (params, signal) => {
    console.log(params, signal, "params, signal");

    return TotalReportsService.getForecastReport(params, signal);
  }
);

export const getAnalyticsCountInboundByHourForForecast = createAsyncThunk(
  "totalReports/getAnalyticsCountInboundByHourForForecast",
  async (params, signal) => {
    return TotalReportsService.getBookingsCount(
      { ...params, type: "inbound", byHour: true, source: 'none' },
      signal
    );
  }
);
export const getSLAReport = createAsyncThunk(
  "totalReports/getSLAReport",
  async (params) => {
    return TotalReportsService.getSLAReport(params);
  }
);

export const getAirlinePerformanceReport = createAsyncThunk(
  "totalReports/getAirlinePerformanceReport",
  async (params) => {
    return TotalReportsService.getAirlinePerformanceReport(params);
  }
);
export const getEmployeeConvReport = createAsyncThunk(
  "totalReports/getEmployeeConvReport",
  async (params) => {
    return TotalReportsService.getEmployeeConvReport(params);
  }
);

export const getFlightsListReport = createAsyncThunk(
  "totalReports/getFlightsListReport",
  async (params) => {
    return TotalReportsService.getFlightsListReport(params);
  }
);

export const getFlightMessagesByConversationId = createAsyncThunk(
  "totalReports/getFlightMessagesByConversationId",
  async (params) => {
    return TotalReportsService.getFlightMessagesByConversationId(params);
  }
);

export const getFlightsScheduleReport = createAsyncThunk(
  "totalReports/getFlightsScheduleReport",
  async (params) => {
    return TotalReportsService.getFlightsScheduleReport(params);
  }
);

export const getBreaksReport = createAsyncThunk(
  "totalReports/getBreaksReport",
  async (params) => {
    return TotalReportsService.getBreaksReport(params);
  }
);

export const getGateChangesReport = createAsyncThunk(
  "totalReports/getGateChangesReport",
  async (params) => {
    return TotalReportsService.getGateChangesReport(params);
  }
);

export const getVehicleReport = createAsyncThunk(
  "totalReports/getVehicleReport",
  async (params) => {
    return TotalReportsService.getEquipmentReport(params);
  }
);

export const getThirdStateFlightsReport = createAsyncThunk(
  "totalReports/getThirdStateFlightsReport",
  async (params) => {
    return TotalReportsService.getThirdStateFlightsReport(params);
  }
);

export const getSunflowerLanyardReport = createAsyncThunk(
  "totalReports/getSunflowerLanyardReport",
  async (params) => {
    return TotalReportsService.getSunflowerLanyardReport(params);
  }
);



const totalReportsSlice = createSlice({
  name: "totalReports",
  initialState,
  reducers: {
    reset: (state) => initialState,
    selectReport: (state, action) => {
      state.selectedReport = action.payload;
    },
    resetLoadingStatus: (state) => {
      state.loadingStatus = "idle";
    },
    resetForecastStatusFlags: (state) => {
      state.getDepartureForecastReportStatus = "idle";
      state.getArrivalForecastReportStatus = "idle";

    },

    resetFlightMessagesByConversationIdStatusFlags: (state) => {
      state.getFlightMessagesByConversationIdStatus = "idle";
      state.flightMessagesByConversationId = [];
      state.getFlightMessagesByConversationIdError = null;
    },
  },
  extraReducers: {
    [getDepartureBookingsReport.pending]: (state) => {
      state.getDepartureBookingsReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getDepartureBookingsReport.fulfilled]: (state, action) => {
      state.getDepartureBookingsReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.departureBookingsReport = action.payload;
    },
    [getDepartureBookingsReport.rejected]: (state, action) => {
      state.getDepartureBookingsReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getDepartureBookingsReportError = action.error.message;
    },

    [getArrivalsBookingsReport.pending]: (state) => {
      state.getArrivalBookingsReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getArrivalsBookingsReport.fulfilled]: (state, action) => {
      state.getArrivalBookingsReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.arrivalBookingsReport = action.payload;
    },
    [getArrivalsBookingsReport.rejected]: (state, action) => {
      state.getArrivalBookingsReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getArrivalBookingsReportError = action.error.message;
    },

    [getPassengersRecordReport.pending]: (state) => {
      state.getPassengersRecordReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getPassengersRecordReport.fulfilled]: (state, action) => {
      state.getPassengersRecordReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.passengersRecordReport = action.payload;
    },
    [getPassengersRecordReport.rejected]: (state, action) => {
      state.getPassengersRecordReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getPassengersRecordReportError = action.error.message;
    },

    [getDepartureForecastReport.pending]: (state) => {
      state.getDepartureForecastReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getDepartureForecastReport.fulfilled]: (state, action) => {
      state.getDepartureForecastReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.departureForecastReport = action.payload;
    },
    [getDepartureForecastReport.rejected]: (state, action) => {
      state.getDepartureForecastReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getDepartureForecastReportError = action.error.message;
      console.log(action.error.message, "action.error.message22222");

    },

    [getAnalyticsCountOutboundByHourForForecast.pending]: (state) => {
      state.getAnalyticsCountOutboundByHourForForecastStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getAnalyticsCountOutboundByHourForForecast.fulfilled]: (state, action) => {
      state.getAnalyticsCountOutboundByHourForForecastStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.analyticsCountOutboundByHourForForecast = action.payload;
    },
    [getAnalyticsCountOutboundByHourForForecast.rejected]: (state, action) => {
      console.log(action.error.message, "action.error.message11111");

      state.getAnalyticsCountOutboundByHourForForecastStatus = "failed";
      state.loadingStatus = "failed";
      state.getAnalyticsCountOutboundByHourForForecastError = action.error.message;
    },

    [getArrivalForecastReport.pending]: (state) => {
      state.getArrivalForecastReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getArrivalForecastReport.fulfilled]: (state, action) => {
      state.getArrivalForecastReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.arrivalForecastReport = action.payload;
    },
    [getArrivalForecastReport.rejected]: (state, action) => {
      state.getArrivalForecastReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getArrivalForecastReportError = action.error.message;
    },

    [getAnalyticsCountInboundByHourForForecast.pending]: (state) => {
      state.getAnalyticsCountInboundByHourForForecastStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getAnalyticsCountInboundByHourForForecast.fulfilled]: (state, action) => {
      state.getAnalyticsCountInboundByHourForForecastStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.analyticsCountInboundByHourForForecast = action.payload;
    },
    [getAnalyticsCountInboundByHourForForecast.rejected]: (state, action) => {
      state.getAnalyticsCountInboundByHourForForecastStatus = "failed";
      state.loadingStatus = "failed";
      state.getAnalyticsCountInboundByHourForForecastError = action.error.message;
    },

    [getSLAReport.pending]: (state) => {
      state.getSLAReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getSLAReport.fulfilled]: (state, action) => {
      state.getSLAReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.SLAReport = action.payload;
    },
    [getSLAReport.rejected]: (state, action) => {
      state.getSLAReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getSLAReportError = action.error.message;
    },

    [getAirlinePerformanceReport.pending]: (state) => {
      state.getAirlinePerformanceReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getAirlinePerformanceReport.fulfilled]: (state, action) => {
      state.getAirlinePerformanceReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.AirlinePerformanceReport = action.payload;
    },
    [getAirlinePerformanceReport.rejected]: (state, action) => {
      state.getAirlinePerformanceReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getAirlinePerformanceReportError = action.error.message;
    },

    [getEmployeeConvReport.pending]: (state) => {
      state.getEmployeeConvReportStatus = "loading";
    },
    [getEmployeeConvReport.fulfilled]: (state, action) => {
      state.getEmployeeConvReportStatus = "succeeded";
      state.employeeConvReport = action.payload;
    },
    [getEmployeeConvReport.rejected]: (state, action) => {
      state.getEmployeeConvReportStatus = "failed";
      state.getEmployeeConvReportError = action.error.message;
    },

    [getFlightsListReport.pending]: (state) => {
      state.getFlightsListReportStatus = "loading";
    },
    [getFlightsListReport.fulfilled]: (state, action) => {
      state.getFlightsListReportStatus = "succeeded";
      state.flightsListReport = action.payload;
    },
    [getFlightsListReport.rejected]: (state, action) => {
      state.getFlightsListReportStatus = "failed";
      state.getFlightsListReportError = action.error.message;
    },

    [getFlightMessagesByConversationId.pending]: (state) => {
      state.getFlightMessagesByConversationIdStatus = "loading";
    },
    [getFlightMessagesByConversationId.fulfilled]: (state, action) => {
      state.getFlightMessagesByConversationIdStatus = "succeeded";
      state.flightMessagesByConversationId = action.payload;
    },
    [getFlightMessagesByConversationId.rejected]: (state, action) => {
      state.getFlightMessagesByConversationIdStatus = "failed";
      state.getFlightMessagesByConversationIdError = action.error.message;
    },

    [getFlightsScheduleReport.pending]: (state) => {
      state.getFlightsScheduleReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getFlightsScheduleReport.fulfilled]: (state, action) => {
      state.getFlightsScheduleReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.flightsScheduleReport = action.payload;
    },
    [getFlightsScheduleReport.rejected]: (state, action) => {
      state.getFlightsScheduleReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getFlightsScheduleReportError = action.error.message;
    },

    [getBreaksReport.pending]: (state) => {
      state.getBreaksReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getBreaksReport.fulfilled]: (state, action) => {
      state.getBreaksReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.breaksReport = action.payload;
    },
    [getBreaksReport.rejected]: (state, action) => {
      state.getBreaksReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getBreaksReportError = action.error.message;
    },

    [getGateChangesReport.pending]: (state) => {
      state.getGateChangesReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getGateChangesReport.fulfilled]: (state, action) => {
      state.getGateChangesReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.gateChangesReport = action.payload;
    },
    [getGateChangesReport.rejected]: (state, action) => {
      state.getGateChangesReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getGateChangesReportError = action.error.message;
    },

    [getVehicleReport.pending]: (state) => {
      state.getVehicleReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getVehicleReport.fulfilled]: (state, action) => {
      state.getVehicleReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.vehicleReport = action.payload;
    },
    [getVehicleReport.rejected]: (state, action) => {
      state.getVehicleReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getVehicleReportError = action.error.message;
    },

    [getThirdStateFlightsReport.pending]: (state) => {
      state.getThirdStateFlightsReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getThirdStateFlightsReport.fulfilled]: (state, action) => {
      state.getThirdStateFlightsReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.thirdStateFlightsReport = action.payload;
    },
    [getThirdStateFlightsReport.rejected]: (state, action) => {
      state.getThirdStateFlightsReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getThirdStateFlightsReportError = action.error.message;
    },

    [getSunflowerLanyardReport.pending]: (state) => {
      state.getSunflowerReportStatus = "loading";
      state.loadingStatus = "loading";
    },
    [getSunflowerLanyardReport.fulfilled]: (state, action) => {
      state.getSunflowerReportStatus = "succeeded";
      state.loadingStatus = "succeeded";
      state.sunflowerReport = action.payload;
    },
    [getSunflowerLanyardReport.rejected]: (state, action) => {
      state.getSunflowerReportStatus = "failed";
      state.loadingStatus = "failed";
      state.getSunflowerReportError = action.error.message;
    },

  },
});

export const {
  reset,
  selectReport,
  resetLoadingStatus,
  resetForecastStatusFlags,
  resetFlightMessagesByConversationIdStatusFlags
} = totalReportsSlice.actions;

export const selectDepartureBookingsReport = (state) => state.totalReports.departureBookingsReport;
export const selectGetDepartureBookingsReportStatus = (state) => state.totalReports.getDepartureBookingsReportStatus;

export const selectArrivalBookingsReport = (state) => state.totalReports.arrivalBookingsReport;
export const selectGetArrivalBookingsReportStatus = (state) => state.totalReports.getArrivalBookingsReportStatus;

export const selectSelectedReport = (state) => state.totalReports.selectedReport;

export const selectTotalReportsLoadingStatus = (state) => state.totalReports.loadingStatus;

export const selectArrivalForecastReport = (state) => {
  // copy the inbound flight data w/ actual counts
  let inboundFlightData = {};

  for (let k in state.totalReports.analyticsCountInboundByHourForForecast) {
    // need to remove the date from the key
    inboundFlightData[k.split("_")[2]] =
      state.totalReports.analyticsCountInboundByHourForForecast[k];
  }

  // initalize list that will hold the forecasted arrivals
  let list = [];

  const arrivalFlightsForecast = state.totalReports.arrivalForecastReport?.bookings
  for (let indexCounter in arrivalFlightsForecast) {
    let booking = arrivalFlightsForecast[indexCounter];

    // extract variables from booking
    let id = booking.id;
    let departureAirport = booking.key[5];
    let arrivalAirport = booking.key[6];
    let flight = booking.key[3];
    let arrivalTime = new Date(booking.key[6])
    let options = { hour: '2-digit', minute: '2-digit', hour12: false };
    let time = arrivalTime.toLocaleTimeString('en-GB', options);

    let average = booking.value;

    let formattedTime = ""

    if (arrivalTime && arrivalTime != null && arrivalTime != 'Invalid Date') {
      formattedTime = arrivalTime?.toISOString()?.split('T')[0]; // created formatted time used for sorting list in order of time
    }
    else {
      formattedTime = arrivalTime
    }

    // find actual using flight info + inbound flight data
    let actual = inboundFlightData[flight] || 0;

    // calculate variance
    let variance = average - actual;
    list.push({
      count: indexCounter,
      flight: flight,
      time: time,
      formattedTime: formattedTime,
      average: average ? average.toFixed(1) : 0,
      actual: actual,
      variance: variance ? variance.toFixed(1) : 0,
      id: id,
    });
  }

  // console.log('list:', list)

  let timeFormattedList = list.sort(
    (a, b) => a.formattedTime - b.formattedTime
  );
  const result = convertArrayToCSV(timeFormattedList)
  return result;
};

export const selectDepartureForecastReport = (state) => {
  // copy the inbound flight data w/ actual counts
  let inboundFlightData = {};

  for (let k in state.totalReports.analyticsCountOutboundByHourForForecast) {
    // need to remove the date from the key
    inboundFlightData[k.split("_")[2]] =
      state.totalReports.analyticsCountOutboundByHourForForecast[k];
  }

  let list = [];
  const departuresForecastFlights = state.totalReports.departureForecastReport?.bookings
  for (let indexCounter in departuresForecastFlights) {
    let booking = departuresForecastFlights[indexCounter];


    // extract variables from booking
    let id = booking.id;
    let departureAirport = booking.key[4];
    let arrivalAirport = booking.key[5];
    let flight = booking.key[3];
    let departureTime = new Date(booking.key[6])
    let options = { hour: '2-digit', minute: '2-digit', hour12: false };
    let time = departureTime.toLocaleTimeString('en-GB', options);

    let average = booking.value;

    let formattedTime = ""

    if (departureTime && departureTime != null && departureTime != 'Invalid Date') {
      formattedTime = departureTime.toISOString().split('T')[0]
    }
    else { formattedTime = departureTime }

    // find actual using flight info + inbound flight data
    let actual = inboundFlightData[flight] || 0;

    // calculate variance
    let variance = average - actual;

    let noShowAverage = booking.key[7] ? booking.key[7] : 0;

    list.push({
      count: indexCounter,
      flight: flight,
      time: time,
      formattedTime: formattedTime,
      average: average ? average.toFixed(1) : 0,
      actual: actual,
      variance: variance ? variance.toFixed(1) : 0,
      id: id,
      noShowAverage,
      noShowAverage,
    });
  }

  let timeFormattedList = list.sort(
    (a, b) => a.formattedTime - b.formattedTime
  );

  const result = convertArrayToCSV(timeFormattedList)
  return result;
};

export const selectGetDepartureForecastReportStatus = (state) => state.totalReports.getDepartureForecastReportStatus;
export const selectGetArrivalForecastReportStatus = (state) => state.totalReports.getArrivalForecastReportStatus;
export const selectPassengersRecordReport = (state) => state.totalReports.passengersRecordReport;
export const selectSLAChartData = (state) => {
  if (!state.totalReports.SLAReport) return null;
  let SLAdata = state.totalReports.SLAReport
  let SLAInbound = [];
  let SLAOutbound = [];
  let SLACancelledOutbound = [];
  let SLACancelledInbound = [];

  SLAInbound.push(
    {
      name: "Inbound PreAdvised",
      ["<10Min"]: SLAdata?.inboundPreAdvised?.lessThan10,
      ["<20Min"]: SLAdata?.inboundPreAdvised?.lessThan20,
      ["<30Min"]: SLAdata?.inboundPreAdvised?.lessThan30,
      [">30Min"]: SLAdata?.inboundPreAdvised?.moreThan30,
      ["Total"]: SLAdata?.inboundPreAdvised?.total,
    },
    {
      name: "Inbound Non-PreAdvised",
      ["<15Min"]: SLAdata?.inboundNonPreAdvised?.lessThan15,
      ["<25Min"]: SLAdata?.inboundNonPreAdvised?.lessThan25,
      ["<35Min"]: SLAdata?.inboundNonPreAdvised?.lessThan35,
      [">35Min"]: SLAdata?.inboundNonPreAdvised?.moreThan35,
      ["Total"]: SLAdata?.inboundNonPreAdvised?.total,
    },
  );
  SLAOutbound.push(
    {
      name: "Outbound PreAdvised",
      ["<10Min"]: SLAdata?.outboundPreAdvised?.lessThan10,
      ["<20Min"]: SLAdata?.outboundPreAdvised?.lessThan20,
      ["<30Min"]: SLAdata?.outboundPreAdvised?.lessThan30,
      [">30Min"]: SLAdata?.outboundPreAdvised?.moreThan30,
      ["Total"]: SLAdata?.outboundPreAdvised?.total,
    },
    {
      name: "Outbound Non-PreAdvised",
      ["<15Min"]: SLAdata?.outboundNonPreAdvised?.lessThan15,
      ["<25Min"]: SLAdata?.outboundNonPreAdvised?.lessThan25,
      ["<35Min"]: SLAdata?.outboundNonPreAdvised?.lessThan35,
      [">35Min"]: SLAdata?.outboundNonPreAdvised?.moreThan35,
      ["Total"]: SLAdata?.outboundNonPreAdvised?.total,
    },

  );
  SLACancelledOutbound.push(
    { name: "Cancelled Outbound", CancelledPreAdvised: SLAdata?.departuresCancelledPreAdvised, CancelledNonPreAdvised: SLAdata?.departuresCancelledNonPreAdvised },
  );
  SLACancelledInbound.push(
    { name: "Cancelled Inbound", CancelledPreAdvised: SLAdata?.arrivalsCancelledPreAdvised, CancelledNonPreAdvised: SLAdata?.arrivalsCancelledNonPreAdvised },
  );
  return {
    SLAInbound,
    SLAOutbound,
    SLACancelledOutbound,
    SLACancelledInbound
  }
};

export const selectAirlinePerformanceChartData = (state) => {
  const AirlinePerformancedata = state.totalReports.AirlinePerformanceReport;
  if (!AirlinePerformancedata) {
    return null; // Handle the case where the data is not available
  }
  // Calculate totals dynamically based on the array lengths
  const AirlinePerformanceInbound = [
    {
      name: "Inbound PreAdvised",
      Total: AirlinePerformancedata.arrivalsPreAdvised?.length || 0,
    },
    {
      name: "Inbound Non-PreAdvised",
      Total: AirlinePerformancedata.arrivalsNonPreAdvised?.length || 0,
    },
    {
      name: "Inbound Walk Ups",
      Total: AirlinePerformancedata.arrivalsWalkUps?.length || 0,
    },
  ];
  const AirlinePerformanceOutbound = [
    {
      name: "Outbound PreAdvised",
      Total: AirlinePerformancedata.departuresPreAdvised?.length || 0,
    },
    {
      name: "Outbound Non-PreAdvised",
      Total: AirlinePerformancedata.departuresNonPreAdvised?.length || 0,
    },
    {
      name: "Outbound WalkUps",
      Total: AirlinePerformancedata.departuresWalkUps?.length || 0,
    },
  ];
  return {
    AirlinePerformanceInbound,
    AirlinePerformanceOutbound,
  };
};

export const selectSLAReport = (state) => state.totalReports.SLAReport;
export const selectAirlinePerformanceReport = (state) => state.totalReports.AirlinePerformanceReport;

export const selectEmployeeConvReport = (state) => state.totalReports.employeeConvReport;
export const selectGetEmployeeConvReportStatus = (state) => state.totalReports.getEmployeeConvReportStatus;

export const selectFlightsListReport = (state) => state.totalReports.flightsListReport;
export const selectGetFlightsListReportStatus = (state) => state.totalReports.getFlightsListReportStatus;

export const selectFlightMessagesByConversationId = (state) => state.totalReports.flightMessagesByConversationId;
export const selectGetFlightMessagesByConversationIdStatus = (state) => state.totalReports.getFlightMessagesByConversationIdStatus;

// flight report
export const selectFlightsScheduleReport = (state) => state.totalReports.flightsScheduleReport;
export const selectGetFlightsScheduleReportStatus = (state) => state.totalReports.getFlightsScheduleReportStatus;

export const selectFlightsScheduleReportData = (state) => {
  const flightsScheduleReportData = state.totalReports.flightsScheduleReport?.flights;
  return flightsScheduleReportData;
}

export const selectFlightsScheduleColumns = (state) => {
  const isEdiReport = state.totalReports.flightsScheduleReport?.iata === 'EDI';

  if (isEdiReport) {
    return [
      { field: '_id', name: 'Document ID' },
      { field: 'flightNumber', name: 'Flight Number' },
      { field: 'carrierCode', name: 'Carrier Code' },
      { field: 'originalCarrierCode', name: 'Original Carrier Code' },
      { field: 'codeSwitch', name: 'Code Switch' },
      { field: 'number', name: 'Number' },
      { field: 'date', name: 'Date' },
      { field: 'type', name: 'Type' },
      { field: 'departureAirport', name: 'Departure Airport' },
      { field: 'arrivalAirport', name: 'Arrival Airport' },
      { field: 'airportDisplayName', name: 'Airport Display Name' },
      { field: 'originDestAirportDesc', name: 'Origin/Dest Airport Desc' },
      { field: 'originDestAirportICAO', name: 'Origin/Dest Airport ICAO' },
      { field: 'gate', name: 'Gate' },
      { field: 'terminal', name: 'Terminal' },
      { field: 'stand', name: 'Stand' },
      { field: 'operationInfoStatus', name: 'Operation Status' },
      { field: 'operationInfoStatusCode', name: 'Operation Status Code' },
      { field: 'operationInfoStatusType', name: 'Operation Status Type' },
      { field: 'operationInfoTime', name: 'Operation Time' },
      { field: 'scheduledDateTime', name: 'Scheduled Date Time' },
      { field: 'eobt', name: 'EOBT' },
      { field: 'eibt', name: 'EIBT' },
      { field: 'aobt', name: 'AOBT' },
      { field: 'aibt', name: 'AIBT' },
      { field: 'aldt', name: 'ALDT' },
      { field: 'atot', name: 'ATOT' },
      { field: 'boardingStartDateTime', name: 'Boarding Start' },
      { field: 'boardingCompleteDateTime', name: 'Boarding Complete' },
      { field: 'firstBagDateTime', name: 'First Bag' },
      { field: 'lastBagDateTime', name: 'Last Bag' },
      { field: 'gateDueDateTime', name: 'Gate Due' },
      { field: 'startBoardingDateTime', name: 'Start Boarding' },
      { field: 'endBoardingDateTime', name: 'End Boarding' },
      { field: 'finalsDateTime', name: 'Finals Date Time' },
      { field: 'zoneDateTime', name: 'Zone Date Time' },
      { field: 'runway', name: 'Runway' },
      { field: 'aircraftType', name: 'Aircraft Type' },
      { field: 'aircraftTypeDesc', name: 'Aircraft Type Desc' },
      { field: 'aircraftTypeICAO', name: 'Aircraft Type ICAO' },
      { field: 'aircraftRegistration', name: 'Aircraft Registration' },
      { field: 'callSign', name: 'Call Sign' },
      { field: 'airlineDesc', name: 'Airline Desc' },
      { field: 'airlineICAO', name: 'Airline ICAO' },
      { field: 'airlineTicketed', name: 'Airline Ticketed' },
      { field: 'passengerCount', name: 'Passenger Count' },
      { field: 'cancelled', name: 'Cancelled' },
      { field: 'flightStatus', name: 'Flight Status Code' },
      { field: 'gateActionCode', name: 'Gate Action Code' },
      { field: 'gateChangeIndicator', name: 'Gate Change Indicator' },
      { field: 'checkinDeskRange', name: 'Check-in Desk Range' },
      { field: 'checkinStatus', name: 'Check-in Status' },
      { field: 'carousel', name: 'Carousel' },
      { field: 'handlingAgentRamp', name: 'Handling Agent Ramp' },
      { field: 'internationalStatus', name: 'International Status' },
      { field: 'nextInformation', name: 'Next Information' },
      { field: 'serviceType', name: 'Service Type' },
      { field: 'codeshare', name: 'Codeshare' },
      { field: 'codeShareFlights', name: 'Code Share Flights' },
      { field: 'aodbFlightId', name: 'AODB Flight ID' },
      { field: 'aodbUpdatedDateTime', name: 'AODB Updated Date Time' },
      { field: 'operatingStatus', name: 'Operating Status' },
      { field: 'timeDifference', name: 'Time Difference' },
      { field: 'originalFlightTime', name: 'Original Flight Time' },
      { field: 'history', name: 'History' },
      { field: 'manualLock', name: 'Manual Lock' },
      { field: 'createdAt', name: 'Created At' },
      { field: 'updatedAt', name: 'Updated At' },
      { field: 'flightFeedTime', name: 'Flight Feed Time' },
    ];
  }

  return [
    { field: '_id', name: 'Document ID' },
    { field: 'flightIdentity', name: 'Flight Identity' },
    { field: 'flightNumber', name: 'Flight Number' },
    { field: 'flightSuffix', name: 'Flight Suffix' },
    { field: 'carrierIATA', name: 'Carrier IATA' },
    { field: 'carrierICAO', name: 'Carrier ICAO' },
    { field: 'airlineCode', name: 'Airline Code' },
    { field: 'date', name: 'Date' },
    { field: 'type', name: 'Type' },
    { field: 'departureAirport', name: 'Departure Airport' },
    { field: 'arrivalAirport', name: 'Arrival Airport' },
    { field: 'destinationAirportDisplay', name: 'Destination Display' },
    { field: 'originAirportDisplay', name: 'Origin Display' },
    { field: 'portsOfCall', name: 'Ports of Call' },
    { field: 'gate', name: 'Gate' },
    { field: 'terminal', name: 'Terminal' },
    { field: 'passengerTerminal', name: 'Passenger Terminal' },
    { field: 'stand', name: 'Stand' },
    { field: 'pier', name: 'Pier' },
    { field: 'gateInfoGate', name: 'Gate Info - Gate' },
    { field: 'gateBoardingStatus', name: 'Gate Boarding Status' },
    { field: 'gateOpenPlanned', name: 'Gate Open Planned' },
    { field: 'gateOpenActual', name: 'Gate Open Actual' },
    { field: 'gateClosePlanned', name: 'Gate Close Planned' },
    { field: 'gateCloseActual', name: 'Gate Close Actual' },
    { field: 'isAirbridgeUsed', name: 'Airbridge Is Used' },
    { field: 'airbridgeNumber', name: 'Airbridge Number' },
    { field: 'checkinDeskRange', name: 'Check-in Desk Range' },
    { field: 'checkinZone', name: 'Check-in Zone' },
    { field: 'baggageCarouselID', name: 'Baggage Carousel ID' },
    { field: 'flightStatus', name: 'Flight Status Code' },
    { field: 'flightStatusCodeCDM', name: 'Flight Status CDM' },
    { field: 'flightSectorCode', name: 'Flight Sector Code' },
    { field: 'flightServiceType', name: 'Flight Service Type' },
    { field: 'flightInformation', name: 'Flight Information' },
    { field: 'operationInfoStatus', name: 'Operation Status' },
    { field: 'operationInfoStatusType', name: 'Operation Status Type' },
    { field: 'operationInfoTime', name: 'Operation Time' },
    { field: 'operationInfoCache', name: 'Operation Cache' },
    { field: 'actualOnBlocksDateTime', name: 'Actual On Blocks' },
    { field: 'actualOffBlocksDateTime', name: 'Actual Off Blocks' },
    { field: 'estimatedOnBlocksDateTime', name: 'Estimated On Blocks' },
    { field: 'estimatedOffBlocksDateTime', name: 'Estimated Off Blocks' },
    { field: 'targetOffBlocksDateTime', name: 'Target Off Blocks' },
    { field: 'estimatedDateTime', name: 'Estimated Date Time' },
    { field: 'finalApproachDateTime', name: 'Final Approach' },
    { field: 'firstBagDateTime', name: 'First Bag' },
    { field: 'lastBagDateTime', name: 'Last Bag' },
    { field: 'scheduledDateTime', name: 'Scheduled Date Time' },
    { field: 'targetStartupApprovalDateTime', name: 'Target Startup Approval' },
    { field: 'wheelsDownDateTime', name: 'Wheels Down' },
    { field: 'wheelsUpDateTime', name: 'Wheels Up' },
    { field: 'estimatedWheelsDownDateTime', name: 'Estimated Wheels Down' },
    { field: 'estimatedWheelsUpDateTime', name: 'Estimated Wheels Up' },
    { field: 'startBoardingDateTimeOT', name: 'Start Boarding (OT)' },
    { field: 'endBoardingDateTimeOT', name: 'End Boarding (OT)' },
    { field: 'secondCallDateTimeOT', name: 'Second Call (OT)' },
    { field: 'publicDateTime', name: 'Public Date Time' },
    { field: 'startBoardingDateTime', name: 'Start Boarding' },
    { field: 'endBoardingDateTime', name: 'End Boarding' },
    { field: 'secondCallDateTime', name: 'Second Call' },
    { field: 'aircraftType', name: 'Aircraft Type' },
    { field: 'aircraftRegistration', name: 'Aircraft Registration' },
    { field: 'callSign', name: 'Call Sign' },
    { field: 'passengerCount', name: 'Passenger Count' },
    { field: 'linkedFlightKey', name: 'Linked Flight Key' },
    { field: 'linkedFlightIdentity', name: 'Linked Flight Identity' },
    { field: 'linkedFlightScheduledDate', name: 'Linked Flight Scheduled Date' },
    { field: 'linkedFlightCarrierIATA', name: 'Linked Flight Carrier IATA' },
    { field: 'linkedFlightNumber', name: 'Linked Flight Number' },
    { field: 'linkedFlightSuffix', name: 'Linked Flight Suffix' },
    { field: 'shareFlights', name: 'Code Share Flights' },
    { field: 'cdmCalculatedTakeOff', name: 'CDM Calculated Take Off' },
    { field: 'cdmTargetTakeOff', name: 'CDM Target Take Off' },
    { field: 'cdmActualStartUpApproval', name: 'CDM Actual Startup Approval' },
    { field: 'cdmActualStartUpRequest', name: 'CDM Actual Startup Request' },
    { field: 'cdmEstimatedOffBlocks', name: 'CDM Estimated Off Blocks' },
    { field: 'cdmCBPFlightIndicator', name: 'CDM CBP Flight Indicator' },
    { field: 'createdAt', name: 'Created At' },
    { field: 'updatedAt', name: 'Updated At' },
    { field: 'history', name: 'History' },
    { field: 'originalFlightTime', name: 'Original Flight Time' },
    { field: 'timeDifference', name: 'Time Difference' },
    { field: 'operatingStatus', name: 'Operating Status' },
    { field: 'createdResponseCache', name: 'Created Response Cache' }
  ];
};

// breaks report
export const selectBreaksReport = (state) => state.totalReports.breaksReport;
export const selectGetBreaksReportStatus = (state) => state.totalReports.getBreaksReportStatus;

export const selectGateChangesReport = (state) => state.totalReports.gateChangesReport;
export const selectGetGateChangesReportStatus = (state) => state.totalReports.getGateChangesReportStatus;

export const selectVehicleReport = (state) => state.totalReports.vehicleReport;
export const selectGetVehicleReportStatus = (state) => state.totalReports.getVehicleReportStatus;

export const selectThirdStateFlightsReport = (state) => state.totalReports.thirdStateFlightsReport;
export const selectGetThirdStateFlightsReportStatus = (state) => state.totalReports.getThirdStateFlightsReportStatus;

export const selectSunflowerReport = (state) => state.totalReports.sunflowerReport;
export const selectGetSunflowerReportStatus = (state) => state.totalReports.getSunflowerReportStatus;

export default totalReportsSlice.reducer;